import router from './../router'
import axios from 'axios'
import { Message } from 'element-ui'
import store from './../store'

// create an axios instance
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 10000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    let token = ''
    try {
      token = store.getters.token || JSON.parse(localStorage.getItem('token'))
    } catch (e) {
      console.error(e)
    }
    if (token) {
      // let each request carry token
      config.headers['token'] = token
    }
    config.headers.source = 'pc'
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor 响应拦截器
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200) {
      if (res.code === 4001) {
        // 没有Token
        const _path = router.history.current.path || ''
        const _query = router.history.current.query || {}
        _query.redirect = _path
        router.push({ path: '/login', query: _query })
        sessionStorage.clear()
      } else if (res.code === 4000) {
        // Token过期
        const _path = router.history.current.path || ''
        const _query = router.history.current.query || {}
        _query.redirect = _path
        router.push({ path: '/login', query: _query })
        sessionStorage.clear()
        localStorage.clear()

        Message({
          message: res.message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      } else {
        Message({
          message: res.message || 'Error',
          type: 'error',
          duration: 5 * 1000
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return res
    }
  },
  error => {
    console.log('err' + error) // for debug
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

export default service
